import HttpClient from "@/common/boot/HttpClient"
import criarToast from '@/common/boot/ToastsHandler';
import { CTRL_MODULOS } from '@/common/boot/Constantes'
import { ticketParaWorkflow } from '../helpers/workflowNormalizer'

const listarWorkflowsRecuperacao = async ({ commit, rootGetters }, payload) => {
  commit('CARREGANDO', true)
  try {
    const provedorAtivo = localStorage.getItem('provedorAtivo')
    const moduloAtivo = rootGetters['ctrlModulos/moduloAtivo']
    const segmento = moduloAtivo == CTRL_MODULOS.INSTALACAO ? 'instalacao' : 'recuperacao'
    const response = await HttpClient.post(
      `/pco-workflows/${segmento}/tickets/${provedorAtivo}/visualizar`,
      payload
    )
    commit('LISTAR_DADOS', (response.data.data.data || []).map(ticket => ticketParaWorkflow(ticket, moduloAtivo)))
    commit('ATUALIZAR_PAGINACAO', response.data.data)
    return response
  } catch (error) {
    console.error('Erro ao listar workflows de recuperação:', error)
    commit('LISTAR_DADOS', [])
    commit('ATUALIZAR_PAGINACAO', null)
  } finally {
    commit('CARREGANDO', false)
  }
}

const vincularTarefaAoTicket = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  try {
    const response = await HttpClient.post(
      `pco-workflows/${payload.id}/vincular-tarefa`,
      { ctrl_tarefa_id: payload.ctrl_tarefa_id }
    );

    if (response.data) {
      criarToast({
        tipo: 'success',
        mensagem: 'Tarefa vinculada com sucesso!'
      });
      return response.data;
    }
  } catch (error) {
    criarToast({
      tipo: 'error',
      mensagem: 'Erro ao vincular tarefa'
    });
    console.error('Erro ao vincular tarefa:', error);
    return false;
  } finally {
    commit('CARREGANDO', false);
  }
}

const exportarWorkflowsRecuperacao = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  try {
    const provedorAtivo = localStorage.getItem('provedorAtivo');

    const response = await HttpClient.post(
      `/pco-workflows/recuperacao/tickets/${provedorAtivo}/exportar`,
      payload,
      { responseType: 'blob' }
    );

    const contentType =
      response.headers['content-type'] || 'application/octet-stream';

    const blob = new Blob([response.data], { type: contentType });

    const disposition = response.headers['content-disposition'];
    let fileName = 'exportacao';

    if (disposition) {
      const match = disposition.match(/filename="?(.+?)"?$/);
      if (match && match[1]) {
        fileName = match[1];
      }
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error('Erro ao exportar workflows de recuperação:', error);
  } finally {
    commit('CARREGANDO', false);
  }
};

export {
  listarWorkflowsRecuperacao,
  vincularTarefaAoTicket,
  exportarWorkflowsRecuperacao,
}
